// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";

export const exportInvoiceHistoryUrl = "/api/sainc/export/invoices";

export async function exportInvoiceHistory(invoicesParameter: GetInvoicesApiParameter): Promise<ServiceResult<string>> {
    try {
        const exportInvoiceHistoryModel = await get<string>(exportInvoiceHistoryUrl, invoicesParameter);
        return {
            result: exportInvoiceHistoryModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error.errorJson.message,
        };
    }
}
